import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ADMIN_HEADER_USER, AdminAuthService } from './admin-auth.service';

export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {

  if (!ehRequestAdmin(req.url)) {
    return next(req);
  }

  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  const token = adminAuth.tokenLogado();
  let requisicao = req;
  if (token && !req.headers.get('Authorization')) {
    requisicao = req.clone({
      headers: req.headers.set('Authorization', `Basic ${btoa(`${ADMIN_HEADER_USER}:${token}`)}`)
    });
  }

  return next(requisicao).pipe(
    catchError(erro => {
      if (erro.status === 401 || erro.status === 403) {
        adminAuth.logout();
        router.navigate(['/admin/login']);
      }
      return throwError(() => erro);
    })
  );
};

export function ehRequestAdmin(url: string): boolean {
  if (!url) { return false; }
  if (!url.startsWith(environment.AutenticacaoApi_Url)) { return false; }
  const restante = url.substring(environment.AutenticacaoApi_Url.length);
  return restante.startsWith('/admin/') || restante.startsWith('/admin?') || restante === '/admin';
}
